import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import { LoadingPage } from 'components/molecules/loading-page/LoadingPage';
import { SomethingWentWrong } from 'modules/app/components/pages/something-went-wrong/SomethingWentWrong';
import { PropsWithChildren, ReactNode, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useLocation } from 'react-router-dom';

interface RouteBoundaryProps {
  errorFallback?: JSX.Element;
  loadingFallback?: ReactNode;
}

export const RouteBoundary = ({
  errorFallback,
  loadingFallback,
  children
}: PropsWithChildren<RouteBoundaryProps>) => {
  const { reset } = useQueryErrorResetBoundary();
  const { pathname } = useLocation();
  return (
    <ErrorBoundary
      key={pathname}
      onReset={reset}
      fallback={errorFallback ?? <SomethingWentWrong />}
    >
      <Suspense fallback={loadingFallback ?? <LoadingPage />}>{children}</Suspense>
    </ErrorBoundary>
  );
};
